<div class="topbar" [ngClass]="{ sticky: isSticky, opaque: isOpaque }">
  <div class="logo" (click)="navigateToHome()" (keydown.enter)="navigateToHome()" (keydown.space)="navigateToHome()" tabindex="0">
    <img src="assets/img/footer-logo.webp" alt="Serkan Logo" class="logo-image" />
  </div>
  <!-- Language Switch -->
  <div class="language-switch">
    @for (lang of ['en', 'de', 'tr']; track lang) {
      <span (click)="setLanguage(lang)" (keydown.enter)="setLanguage(lang)" (keydown.space)="setLanguage(lang)" [ngClass]="{ active: lang === currentLang }" tabindex="0">
        {{ lang.toUpperCase() }}
      </span>
    }
  </div>
  <!-- Hamburger Menu -->
  <div class="hamburger-menu" (click)="toggleNavigation()" tabindex="0">
    <span class="first-span"></span>
    <span class="second-span"></span>
    <span class="third-span"></span>
  </div>
  <!-- Navigation Content -->
  <div id="navigation-content" [ngClass]="{ open: isNavigationOpen }">
    <div class="navigation-close" (click)="toggleNavigation()">
      <span class="close-first"></span>
      <span class="close-second"></span>
    </div>
    <div class="navigation-links">
      <a href="https://serkanyarar.dev" data-text="HOME">HOME</a>
      <a href="https://about.serkanyarar.dev" data-text="ABOUT">ABOUT</a>
      <a href="https://blog.serkanyarar.dev" data-text="BLOG">BLOG</a>
      <a href="https://book.serkanyarar.dev" data-text="BOOK">BOOK</a>
      <a href="https://certificate.serkanyarar.dev" data-text="CERTIFICATE">CERTIFICATE</a>
      <a href="https://gamer.serkanyarar.dev" data-text="GAMER">GAMER</a>
      <a href="https://contact.serkanyarar.dev" data-text="CONTACT">CONTACT</a>
    </div>
  </div>
</div>
